exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".spinner-overlap {\n  z-index: 500; }\n\n.alert-padding {\n  padding-bottom: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/modules/networking/networking-vc/gateways/dialogs/add-edit-gateway-wizard.scss
// module id = Sww9
// module chunks = 0